import * as React from "react";
const SvgArrowUpTest = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 7, viewBox: "0 0 10 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.175 6.175L5 2.35833L8.825 6.175L10 5L5 0L0 5L1.175 6.175Z", fill: "#0062CC" }));
export default SvgArrowUpTest;
